module.exports = __webpack_public_path__ + "img/StéphanieJacques-ScottRothstein.c9574480.jpg";